/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountInstanceRef,
  DiscountInstanceRefOptional,
  DiscountInstanceRefMetaI,
  DiscountInstanceRefTrackedI,
} from "./discount-instance-ref";
import {
  DiscountInstanceRefTracked,
  DiscountInstanceRefMeta,
} from "./discount-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DiscountType,
  DiscountTypeOptional,
  DiscountTypeMetaI,
  DiscountTypeTrackedI,
} from "./discount-type";
import { DiscountTypeTracked, DiscountTypeMeta } from "./discount-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemDiscountInstanceFull,
  LineItemDiscountInstanceFullOptional,
  LineItemDiscountInstanceFullMetaI,
  LineItemDiscountInstanceFullTrackedI,
} from "./line-item-discount-instance-full";
import {
  LineItemDiscountInstanceFullTracked,
  LineItemDiscountInstanceFullMeta,
} from "./line-item-discount-instance-full";

/**
 *
 * @export
 * @interface LineItemDiscountDTO
 */
export interface LineItemDiscountDTOOptional extends LineItemDiscountInstanceFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  assignId?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isApplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isAutoApplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isUnapplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isAutoAddProcessed?: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemDiscountDTO
   */
  discountType?: DiscountType;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  specifiedCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountDTO
   */
  specifiedPercent?: string;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  amountBaseCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  amountTotalCents?: number;
  /**
   *
   * @type {DiscountInstanceRef}
   * @memberof LineItemDiscountDTO
   */
  discountInstanceId?: DiscountInstanceRefOptional;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountDTO
   */
  appliedCode?: string;
}

export interface LineItemDiscountDTO
  extends LineItemDiscountDTOOptional, LineItemDiscountInstanceFull {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  assignId: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isApplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isAutoApplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isUnapplied?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isAutoAddProcessed?: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemDiscountDTO
   */
  discountType: DiscountType;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  specifiedCents?: number;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountDTO
   */
  specifiedPercent?: string;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  amountBaseCents?: number;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  amountTotalCents?: number;
  /**
   *
   * @type {DiscountInstanceRef}
   * @memberof LineItemDiscountDTO
   */
  discountInstanceId?: DiscountInstanceRef;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountDTO
   */
  appliedCode?: string;
}

export interface LineItemDiscountDTOTrackedI extends LineItemDiscountInstanceFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isApplied?: boolean;
  isAppliedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isAutoApplied?: boolean;
  isAutoAppliedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isUnapplied?: boolean;
  isUnappliedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemDiscountDTO
   */
  isAutoAddProcessed?: boolean;
  isAutoAddProcessedIsSet: boolean;
  /**
   *
   * @type {DiscountType}
   * @memberof LineItemDiscountDTO
   */
  discountType?: DiscountType;
  discountTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  specifiedCents?: number;
  specifiedCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountDTO
   */
  specifiedPercent?: string;
  specifiedPercentIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  amountBaseCents?: number;
  amountBaseCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof LineItemDiscountDTO
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   *
   * @type {DiscountInstanceRef}
   * @memberof LineItemDiscountDTO
   */
  discountInstanceId?: DiscountInstanceRefTrackedI;
  discountInstanceIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemDiscountDTO
   */
  appliedCode?: string;
  appliedCodeIsSet: boolean;
}

transformDatesMap.set(
  "LineItemDiscountDTO",
  function (model: LineItemDiscountDTO) {
    const transformDatesdiscountInstanceId = transformDatesMap.get(
      "DiscountInstanceRef",
    );
    if (transformDatesdiscountInstanceId && model.discountInstanceId) {
      transformDatesdiscountInstanceId(model.discountInstanceId);
    }
  },
);

export type LineItemDiscountDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  isApplied: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isAutoApplied: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isUnapplied: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isAutoAddProcessed: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  discountType: PropertyMeta<DiscountTypeMetaI>;
  //isDate: false
  //isDatetime: false
  specifiedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  specifiedPercent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  amountBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  discountInstanceId: PropertyMeta<DiscountInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  appliedCode: PropertyMeta<MetaTypeBase<string>>;
}>;

export var LineItemDiscountDTOMeta: LineItemDiscountDTOMetaI =
  {} as LineItemDiscountDTOMetaI;
LineItemDiscountDTOMeta = typeMeta("LineItemDiscountDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  isApplied: propertyMeta(
    "isApplied",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isAutoApplied: propertyMeta(
    "isAutoApplied",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isUnapplied: propertyMeta(
    "isUnapplied",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isAutoAddProcessed: propertyMeta(
    "isAutoAddProcessed",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  discountType: propertyMeta(
    "discountType",
    false,
    true,
    false,
    DiscountTypeMeta,
  ),
  specifiedCents: propertyMeta(
    "specifiedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  specifiedPercent: propertyMeta(
    "specifiedPercent",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  amountBaseCents: propertyMeta(
    "amountBaseCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  discountInstanceId: propertyMeta(
    "discountInstanceId",
    false,
    false,
    false,
    DiscountInstanceRefMeta,
  ),
  appliedCode: propertyMeta(
    "appliedCode",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = LineItemDiscountDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([
    LineItemDiscountInstanceFullMeta,
  ]);
  metaI.isDeleted.inheritedFrom = LineItemDiscountInstanceFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = LineItemDiscountInstanceFullMeta.isNew;
  metaI.assignId.inheritedFrom = LineItemDiscountInstanceFullMeta.assignId;
  metaI.isApplied.inheritedFrom = LineItemDiscountInstanceFullMeta.isApplied;
  metaI.isAutoApplied.inheritedFrom =
    LineItemDiscountInstanceFullMeta.isAutoApplied;
  metaI.isUnapplied.inheritedFrom =
    LineItemDiscountInstanceFullMeta.isUnapplied;
  metaI.isAutoAddProcessed.inheritedFrom =
    LineItemDiscountInstanceFullMeta.isAutoAddProcessed;
  metaI.discountType.inheritedFrom =
    LineItemDiscountInstanceFullMeta.discountType;
  metaI.specifiedCents.inheritedFrom =
    LineItemDiscountInstanceFullMeta.specifiedCents;
  metaI.specifiedPercent.inheritedFrom =
    LineItemDiscountInstanceFullMeta.specifiedPercent;
  metaI.amountBaseCents.inheritedFrom =
    LineItemDiscountInstanceFullMeta.amountBaseCents;
  metaI.amountTotalCents.inheritedFrom =
    LineItemDiscountInstanceFullMeta.amountTotalCents;
  metaI.discountInstanceId.inheritedFrom =
    LineItemDiscountInstanceFullMeta.discountInstanceId;
});

export class LineItemDiscountDTOTracked
  extends LineItemDiscountInstanceFullTracked
  implements LineItemDiscountDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  isApplied__I?: boolean = undefined;
  isAppliedIsSet: boolean = false;
  set isApplied(v: undefined | boolean) {
    if (v !== undefined) {
      this.isApplied__I = v;
      this.isAppliedIsSet = true;
    } else {
      this.isApplied__I = v || undefined;
      this.isAppliedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isApplied() {
    return this.isApplied__I;
  }
  isAutoApplied__I?: boolean = undefined;
  isAutoAppliedIsSet: boolean = false;
  set isAutoApplied(v: undefined | boolean) {
    if (v !== undefined) {
      this.isAutoApplied__I = v;
      this.isAutoAppliedIsSet = true;
    } else {
      this.isAutoApplied__I = v || undefined;
      this.isAutoAppliedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isAutoApplied() {
    return this.isAutoApplied__I;
  }
  isUnapplied__I?: boolean = undefined;
  isUnappliedIsSet: boolean = false;
  set isUnapplied(v: undefined | boolean) {
    if (v !== undefined) {
      this.isUnapplied__I = v;
      this.isUnappliedIsSet = true;
    } else {
      this.isUnapplied__I = v || undefined;
      this.isUnappliedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isUnapplied() {
    return this.isUnapplied__I;
  }
  isAutoAddProcessed__I?: boolean = undefined;
  isAutoAddProcessedIsSet: boolean = false;
  set isAutoAddProcessed(v: undefined | boolean) {
    if (v !== undefined) {
      this.isAutoAddProcessed__I = v;
      this.isAutoAddProcessedIsSet = true;
    } else {
      this.isAutoAddProcessed__I = v || undefined;
      this.isAutoAddProcessedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isAutoAddProcessed() {
    return this.isAutoAddProcessed__I;
  }
  discountType__I?: DiscountType = undefined;
  discountTypeIsSet: boolean = false;
  set discountType(v: undefined | DiscountType) {
    if (v !== undefined) {
      this.discountType__I = v;
      this.discountTypeIsSet = true;
    } else {
      this.discountType__I = v || undefined;
      this.discountTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get discountType() {
    return this.discountType__I;
  }
  specifiedCents__I?: number = undefined;
  specifiedCentsIsSet: boolean = false;
  set specifiedCents(v: undefined | number) {
    if (v !== undefined) {
      this.specifiedCents__I = v;
      this.specifiedCentsIsSet = true;
    } else {
      this.specifiedCents__I = v || undefined;
      this.specifiedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get specifiedCents() {
    return this.specifiedCents__I;
  }
  specifiedPercent__I?: string = undefined;
  specifiedPercentIsSet: boolean = false;
  set specifiedPercent(v: undefined | string) {
    if (v !== undefined) {
      this.specifiedPercent__I = v;
      this.specifiedPercentIsSet = true;
    } else {
      this.specifiedPercent__I = v || undefined;
      this.specifiedPercentIsSet = false;
    }
    this.changeTracker = true;
  }
  get specifiedPercent() {
    return this.specifiedPercent__I;
  }
  amountBaseCents__I?: number = undefined;
  amountBaseCentsIsSet: boolean = false;
  set amountBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountBaseCents__I = v;
      this.amountBaseCentsIsSet = true;
    } else {
      this.amountBaseCents__I = v || undefined;
      this.amountBaseCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountBaseCents() {
    return this.amountBaseCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  discountInstanceId__I?: DiscountInstanceRefTracked = undefined;
  discountInstanceIdIsSet: boolean = false;
  set discountInstanceId(v: undefined | DiscountInstanceRefTracked) {
    if (v !== undefined) {
      this.discountInstanceId__I = v;
      this.discountInstanceIdIsSet = true;
    } else {
      this.discountInstanceId__I = v || undefined;
      this.discountInstanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountInstanceId() {
    return this.discountInstanceId__I;
  }
  appliedCode__I?: string = undefined;
  appliedCodeIsSet: boolean = false;
  set appliedCode(v: undefined | string) {
    if (v !== undefined) {
      this.appliedCode__I = v;
      this.appliedCodeIsSet = true;
    } else {
      this.appliedCode__I = v || undefined;
      this.appliedCodeIsSet = false;
    }
    this.changeTracker = true;
  }
  get appliedCode() {
    return this.appliedCode__I;
  }
  constructor(config?: LineItemDiscountDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.discountInstanceId?.setIds();
  }
  assignFrom(
    config: LineItemDiscountDTOOptional,
    options?: AssignOptions,
  ): LineItemDiscountDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.isApplied && this.isAppliedApplyFilter(optionsRequired.filter)) {
      this.isApplied = config.isApplied;
      if (optionsRequired.unassign) this.isAppliedIsSet = false;
      else this.isAppliedIsSet = true;
    }
    if (
      config.isAutoApplied &&
      this.isAutoAppliedApplyFilter(optionsRequired.filter)
    ) {
      this.isAutoApplied = config.isAutoApplied;
      if (optionsRequired.unassign) this.isAutoAppliedIsSet = false;
      else this.isAutoAppliedIsSet = true;
    }
    if (
      config.isUnapplied &&
      this.isUnappliedApplyFilter(optionsRequired.filter)
    ) {
      this.isUnapplied = config.isUnapplied;
      if (optionsRequired.unassign) this.isUnappliedIsSet = false;
      else this.isUnappliedIsSet = true;
    }
    if (
      config.isAutoAddProcessed &&
      this.isAutoAddProcessedApplyFilter(optionsRequired.filter)
    ) {
      this.isAutoAddProcessed = config.isAutoAddProcessed;
      if (optionsRequired.unassign) this.isAutoAddProcessedIsSet = false;
      else this.isAutoAddProcessedIsSet = true;
    }
    if (
      config.discountType &&
      this.discountTypeApplyFilter(optionsRequired.filter)
    ) {
      this.discountType = config.discountType;
      if (optionsRequired.unassign) this.discountTypeIsSet = false;
      else this.discountTypeIsSet = true;
    }
    if (
      config.specifiedCents &&
      this.specifiedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.specifiedCents = config.specifiedCents;
      if (optionsRequired.unassign) this.specifiedCentsIsSet = false;
      else this.specifiedCentsIsSet = true;
    }
    if (
      config.specifiedPercent &&
      this.specifiedPercentApplyFilter(optionsRequired.filter)
    ) {
      this.specifiedPercent = config.specifiedPercent;
      if (optionsRequired.unassign) this.specifiedPercentIsSet = false;
      else this.specifiedPercentIsSet = true;
    }
    if (
      config.amountBaseCents &&
      this.amountBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountBaseCents = config.amountBaseCents;
      if (optionsRequired.unassign) this.amountBaseCentsIsSet = false;
      else this.amountBaseCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (
      config.discountInstanceId &&
      this.discountInstanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.discountInstanceId = new DiscountInstanceRefTracked(
        config.discountInstanceId,
        options,
      );
      if (optionsRequired.unassign) this.discountInstanceIdIsSet = false;
      else this.discountInstanceIdIsSet = true;
    }
    if (
      config.appliedCode &&
      this.appliedCodeApplyFilter(optionsRequired.filter)
    ) {
      this.appliedCode = config.appliedCode;
      if (optionsRequired.unassign) this.appliedCodeIsSet = false;
      else this.appliedCodeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemDiscountDTOTrackedI {
    const cloned = {} as LineItemDiscountDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.isAppliedIsSetDeep() &&
      this.isAppliedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAppliedIsSet = true;
      cloned.isApplied = this.isApplied;
    } else {
      //cloned.isAppliedIsSet = false
    }
    if (
      this.isAutoAppliedIsSetDeep() &&
      this.isAutoAppliedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAutoAppliedIsSet = true;
      cloned.isAutoApplied = this.isAutoApplied;
    } else {
      //cloned.isAutoAppliedIsSet = false
    }
    if (
      this.isUnappliedIsSetDeep() &&
      this.isUnappliedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isUnappliedIsSet = true;
      cloned.isUnapplied = this.isUnapplied;
    } else {
      //cloned.isUnappliedIsSet = false
    }
    if (
      this.isAutoAddProcessedIsSetDeep() &&
      this.isAutoAddProcessedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isAutoAddProcessedIsSet = true;
      cloned.isAutoAddProcessed = this.isAutoAddProcessed;
    } else {
      //cloned.isAutoAddProcessedIsSet = false
    }
    if (
      this.discountTypeIsSetDeep() &&
      this.discountTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountTypeIsSet = true;
      cloned.discountType = this.discountType;
    } else {
      //cloned.discountTypeIsSet = false
    }
    if (
      this.specifiedCentsIsSetDeep() &&
      this.specifiedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.specifiedCentsIsSet = true;
      cloned.specifiedCents = this.specifiedCents;
    } else {
      //cloned.specifiedCentsIsSet = false
    }
    if (
      this.specifiedPercentIsSetDeep() &&
      this.specifiedPercentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.specifiedPercentIsSet = true;
      cloned.specifiedPercent = this.specifiedPercent;
    } else {
      //cloned.specifiedPercentIsSet = false
    }
    if (
      this.amountBaseCentsIsSetDeep() &&
      this.amountBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseCentsIsSet = true;
      cloned.amountBaseCents = this.amountBaseCents;
    } else {
      //cloned.amountBaseCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.discountInstanceIdIsSetDeep() &&
      this.discountInstanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountInstanceIdIsSet = true;
      cloned.discountInstanceId = this.discountInstanceId?.removeUnset(filter);
    } else {
      //cloned.discountInstanceIdIsSet = false
    }
    if (
      this.appliedCodeIsSetDeep() &&
      this.appliedCodeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.appliedCodeIsSet = true;
      cloned.appliedCode = this.appliedCode;
    } else {
      //cloned.appliedCodeIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemDiscountDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.isAppliedApplyFilter(filter)) this.isAppliedIsSet = false;

    if (!this.isAutoAppliedApplyFilter(filter)) this.isAutoAppliedIsSet = false;

    if (!this.isUnappliedApplyFilter(filter)) this.isUnappliedIsSet = false;

    if (!this.isAutoAddProcessedApplyFilter(filter))
      this.isAutoAddProcessedIsSet = false;

    if (!this.discountTypeApplyFilter(filter)) this.discountTypeIsSet = false;

    if (!this.specifiedCentsApplyFilter(filter))
      this.specifiedCentsIsSet = false;

    if (!this.specifiedPercentApplyFilter(filter))
      this.specifiedPercentIsSet = false;

    if (!this.amountBaseCentsApplyFilter(filter))
      this.amountBaseCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.discountInstanceIdApplyFilter(filter))
      this.discountInstanceIdIsSet = false;
    this.discountInstanceId?.unassignAll(filter);

    if (!this.appliedCodeApplyFilter(filter)) this.appliedCodeIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.isDeleted,
      LineItemDiscountDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.isNew,
      LineItemDiscountDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.assignId,
      LineItemDiscountDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  isAppliedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.isApplied,
      LineItemDiscountDTOMeta,
      this.isApplied,
      this,
    );
  }
  isAppliedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isAppliedIsSet && this.isAppliedApplyFilter(filter)) return true;

    return false;
  }
  isAutoAppliedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.isAutoApplied,
      LineItemDiscountDTOMeta,
      this.isAutoApplied,
      this,
    );
  }
  isAutoAppliedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isAutoAppliedIsSet && this.isAutoAppliedApplyFilter(filter))
      return true;

    return false;
  }
  isUnappliedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.isUnapplied,
      LineItemDiscountDTOMeta,
      this.isUnapplied,
      this,
    );
  }
  isUnappliedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isUnappliedIsSet && this.isUnappliedApplyFilter(filter))
      return true;

    return false;
  }
  isAutoAddProcessedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.isAutoAddProcessed,
      LineItemDiscountDTOMeta,
      this.isAutoAddProcessed,
      this,
    );
  }
  isAutoAddProcessedIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.isAutoAddProcessedIsSet &&
      this.isAutoAddProcessedApplyFilter(filter)
    )
      return true;

    return false;
  }
  discountTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.discountType,
      LineItemDiscountDTOMeta,
      this.discountType,
      this,
    );
  }
  discountTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountTypeIsSet && this.discountTypeApplyFilter(filter))
      return true;

    return false;
  }
  specifiedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.specifiedCents,
      LineItemDiscountDTOMeta,
      this.specifiedCents,
      this,
    );
  }
  specifiedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.specifiedCentsIsSet && this.specifiedCentsApplyFilter(filter))
      return true;

    return false;
  }
  specifiedPercentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.specifiedPercent,
      LineItemDiscountDTOMeta,
      this.specifiedPercent,
      this,
    );
  }
  specifiedPercentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.specifiedPercentIsSet && this.specifiedPercentApplyFilter(filter))
      return true;

    return false;
  }
  amountBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.amountBaseCents,
      LineItemDiscountDTOMeta,
      this.amountBaseCents,
      this,
    );
  }
  amountBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseCentsIsSet && this.amountBaseCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.amountTotalCents,
      LineItemDiscountDTOMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  discountInstanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.discountInstanceId,
      LineItemDiscountDTOMeta,
      this.discountInstanceId,
      this,
    );
  }
  discountInstanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.discountInstanceIdIsSet &&
      this.discountInstanceIdApplyFilter(filter)
    )
      return true;
    return this.discountInstanceId?.anySet(filter) == true;

    return false;
  }
  appliedCodeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemDiscountDTOMeta.appliedCode,
      LineItemDiscountDTOMeta,
      this.appliedCode,
      this,
    );
  }
  appliedCodeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.appliedCodeIsSet && this.appliedCodeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.isAppliedIsSetDeep(filter)) return true;
    if (this.isAutoAppliedIsSetDeep(filter)) return true;
    if (this.isUnappliedIsSetDeep(filter)) return true;
    if (this.isAutoAddProcessedIsSetDeep(filter)) return true;
    if (this.discountTypeIsSetDeep(filter)) return true;
    if (this.specifiedCentsIsSetDeep(filter)) return true;
    if (this.specifiedPercentIsSetDeep(filter)) return true;
    if (this.amountBaseCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.discountInstanceIdIsSetDeep(filter)) return true;
    if (this.appliedCodeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
